<template>
  <div class="show_ad">
    <div class="writeinfo">
      <div class="writeinfo_warp animated zoomIn" :style="{width:my.width}">
        <img
          v-if="!launchWeappHtml"
          :class="{ban_select:isBanSelect}"
          :src="my.imgurl"
          @click="goPage(my.url)"
          alt
        />
        <div v-if="launchWeappHtml" v-html="launchWeappHtml" style="width:100%"></div>
        <div class="writeinfo_btns">
          <div class="writeinfo_btns_close saclebtn" @click="clickClose"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";

export default {
  components: {},
  props: {
    /**
     * url
     * width
     */
    my: Object,
  },
  data() {
    return {
      isBanSelect: false,
      launchWeappHtml: "",
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "pageInfo",
      "userInfo",
      "receiveSpreadInfo",
    ]),
  },
  methods: {
    // 点击关闭表单
    clickClose: function () {
      this.$emit("close");
    },
    // 跳转页面
    goPage: function (url) {
      if (!url) {
        return;
      } else {
        this.$emit("close");
        util.openOtherLink(url);
      }
    },
  },
  created() {
    !this.my.width && (this.my.width = "70%");
    if (this.isInMiniProgram) {
      this.isBanSelect = true;
    }
    util
      .checkMapStateCallback(this, [
        "pageInfo",
        "userInfo",
        "receiveSpreadInfo",
      ])
      .then(() => {
        if (util.checkIsHuafa()) {
          let mpPath = "";
          if (this.my.miniUrl) {
            mpPath = this.my.miniUrl;
          } else if (this.my.url && this.my.url.indexOf("/h5/coupon") > -1) {
            let redirect_urlParam = util.getParamFromUrl(this.my.url);
            mpPath = util.getXcxActAreasPath(
              this,
              redirect_urlParam.ctype,
              redirect_urlParam.id,
              redirect_urlParam.psn
            );
          }
          if (mpPath) {
            mpPath = util.handleH5OpenMpPath(mpPath);
            let script = document.createElement("script");
            script.type = "text/wxtag-template";
            script.text = `<img style="width:100%;display:block;border-radius: 10px;min-height: 450px;" src="${this.my.imgurl}">`;
            let html = `<wx-open-launch-weapp style="width:100%;display:block;" username="${util.getOriginalId()}" path="${mpPath}">${
              script.outerHTML
            }</wx-open-launch-weapp>`;
            this.launchWeappHtml = html;
          }
        }
      });
  },
  mounted() {},
};
</script>
<style lang="stylus" scoped>
.writeinfo {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 40;
  color: #ffffff;
}

.writeinfo_warp {
  position: relative;
}

.writeinfo_warp img {
  width: 100%;
  background-color: #ffffff;
  border-radius: 10px;
}

.writeinfo_warp >div {
  margin-top: 0.3rem;
}

.writeinfo_btns {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: space-around;
}

.writeinfo_btns .intro {
  line-height: 0.4rem;
  flex: 1;
  padding: 0 10px;
}

.writeinfo_btns_close {
  width: 0.7rem;
  height: 0.7rem;
  background: url('https://assets.rurushishi.com/yq-rs-wx/components/showimg/close.png') no-repeat center center;
  background-size: 100% 100%;
}

[contenteditable='true'], input, textarea {
  -webkit-user-select: auto !important;
  -khtml-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  -o-user-select: auto !important;
  user-select: auto !important;
}

.ban_select {
  -webkit-touch-callout: none;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  -o-user-select: none !important;
  user-select: none !important;
}
</style>